<template>
    <content-loader
        :height="35"
        :width="270"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#e1e1e1"
    >
        <rect x="8" y="7.55" rx="0" ry="0" :width="width" :height="height"/>
    </content-loader>
</template>

<script>
    import { ContentLoader } from 'vue-content-loader'

    export default {
        props: {
            width: {
                type: [String, Number],
                default: 100
            },

            height: {
                type: [String, Number],
                default: 35
            }
        },

        components: {
            ContentLoader
        }
    }
</script>
